import { render, staticRenderFns } from "./Visit-Detail.vue?vue&type=template&id=2f2b34ab"
import script from "./Visit-Detail.vue?vue&type=script&lang=js"
export * from "./Visit-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports